import { faStar as faStarRegular } from '@fortawesome/pro-regular-svg-icons';
import { faStar as faStarSolid } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { TRANS_KEY_FAVORITES } from '../../data';

export type SaveQueryButtonPropsType = {
  disabled: boolean;
  isSaveActive: boolean;
  onClick: () => void;
};

export const SaveQueryButton: React.FC<SaveQueryButtonPropsType> = ({
  disabled,
  isSaveActive,
  onClick,
}) => {
  const { t } = useTranslation();

  return (
    <Button
      aria-label={t(`${TRANS_KEY_FAVORITES}.SAVE.LABEL`)}
      disabled={disabled}
      variant={isSaveActive ? 'filled' : 'outline'}
      onClick={onClick}
      p={8}
    >
      <FontAwesomeIcon icon={isSaveActive ? faStarSolid : faStarRegular} />
    </Button>
  );
};
